import { Link } from 'wouter'

import { IconContainer } from '@/components/IconContainer'
import { Button } from '@/components/Button'
import { LinkIcon } from '@/icons'

import s from './EmptyState.module.css'

export const EmptyState = () => {
  return (
    <div className={s.container}>
      <IconContainer>{LinkIcon}</IconContainer>
      <div className={s.text}>
        <div className={s.title}>No links yet</div>
        <p className={s.description}>
          Start creating short links for your reading list, research, and more.
        </p>
      </div>
      <Link href="/create">
        <Button variant="primary">Create Link</Button>
      </Link>
    </div>
  )
}
